import Badge from '@/decodo/components/atoms/badge';
import LinkButton from '@/decodo/components/atoms/LinkButton';

export interface PostTopic {
  topic: string;
  slug: string;
}

interface PostTagsProps {
  isNew: boolean;
  topics: PostTopic[];
}

export const PostTags = ({ isNew, topics }: PostTagsProps) => {
  return (
    <div
      className='flex flex-wrap items-center gap-2'
      data-tracker-component='post-tag'
    >
      {isNew && (
        <Badge
          variant='outlined'
          colors='gradient'
          size='l'
          classNames={{ root: 'font-serif' }}
        >
          NEW
        </Badge>
      )}
      {!!topics &&
        topics.map((topic) => <PostTag key={topic.topic} {...topic} />)}
    </div>
  );
};

export const PostTag = ({ slug, topic }: PostTopic) => {
  return (
    <LinkButton
      href={`/blog/topics/${slug}`}
      variant='text'
      color='tertiary'
      underline={false}
      classNames={{
        root: 'p-0 h-[21px] font-serif',
      }}
    >
      <Badge variant='outlined' size='l' colors='gray-300'>
        {topic.toUpperCase()}
      </Badge>
    </LinkButton>
  );
};
